export default function deDupeWarningText(dayWarningMessages) {
    const warningText = dayWarningMessages.map((day) => day.warningText);
    return [...new Set(warningText)];
}
